import analytics from 'shared/lib/analytics';

export default function useAnalytics() {
    return analytics;
}